import { Customer } from 'interfaces/customer';
import { LoyaltySummaryResult, RedeemLoyaltyPointsResult } from 'interfaces/loyalty-program';
import { axios } from 'utils/axios';

interface RequestBase {
  customerId: Customer['customerId'];
}

/**
 * Get loyalty point summary.
 */
export const getLoyaltySummary = async ({
  customerId,
}: RequestBase): Promise<LoyaltySummaryResult> =>
  axios.get<LoyaltySummaryResult>(`/account/loyalty/summary/${customerId}`).then((res) => res.data);

interface RedeemRequest extends RequestBase {
  points: number;
  isFairvalue?: boolean;
}

/**
 * Redeem LoyaltyPoints and convert them into Credits.
 */
export const redeemLoyaltyPoints = async ({
  customerId,
  points,
  isFairvalue = false,
}: RedeemRequest): Promise<RedeemLoyaltyPointsResult> =>
  axios
    .post<RedeemLoyaltyPointsResult>(`/account/loyalty/redeemPoints/${customerId}`, {
      points,
      isFairvalue,
    })
    .then((res) => res.data);
interface RedeemLoyaltyForGiftsInput {
  items: Array<{
    variantId: string;
    quantity: number;
  }>;
}

export interface RedeemLoyaltyForGiftsResult {
  result: {
    message: 'success';
  };
}

/**
 * Redeem points into gifts
 */
export const redeemLoyaltyPointForGifts = async ({
  items,
}: RedeemLoyaltyForGiftsInput): Promise<RedeemLoyaltyForGiftsResult> =>
  axios
    .post<RedeemLoyaltyForGiftsResult>('/loyalty/redemptionGift', {
      items,
    })
    .then((res) => res.data);

export interface GiftItem {
  variantId: number;
  quantity: number;
  points: number;
}
export interface LoyaltyRedemptionGiftInput {
  items: GiftItem[];
  customerId: number;
}

/**
 * Donate points
 */
export const redeemLoyaltyPointForGift = async ({
  items,
  customerId,
}: LoyaltyRedemptionGiftInput): Promise<RedeemLoyaltyForGiftsResult> =>
  axios
    .post<RedeemLoyaltyForGiftsResult>('/loyalty/redemptionGift', {
      items,
      customerId,
    })
    .then((res) => res.data);
